import React from "react";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";
import FormInput from "../../../../utils/FormInput";
import { emailValidator, phoneValidator } from "../../../../utils/formsValidation";
import { useForm } from "react-hook-form";
import ConsentInputs from "../../FinalizePage/ConsentInputs/ConsentInputs";
import { InputsFinalize } from "../../../models/InputsFinalize";

interface IProps {
  register: any;
  errors: any;
  control: any;
}

const FormPart2: React.FC<IProps> = ({ register, errors, control }: IProps) => {
  const { t } = useTranslation();

    const {setValue} = useForm<InputsFinalize>({});

  return (
    <>
      <h3 className="b2b-register-title">Podaj swoje dane do logowania</h3>
      <div className="b2b-register-two-input">
        <FormInput
          name="firstName"
          type="text"
          isLabel
          text="Imię"
          errors={errors}
          register={{ ...register("firstName", { require: true }) }}
          isPlaceholder={false}
        />
        <FormInput
          name="lastName"
          type="text"
          isLabel
          text="Nazwisko"
          errors={errors}
          register={{ ...register("lastName", { require: true }) }}
          isPlaceholder={false}
        />
      </div>
      <FormInput
        name="email"
        type="email"
        isLabel
        text="Adres email"
        errors={errors}
        register={{ ...register("email", { ...emailValidator(true) }) }}
        isPlaceholder={false}
      />
      <FormInput
        name="phone"
        type="text"
        isLabel
        text="Numer telefonu komórowego"
        errors={errors}
        register={{ ...register("phone", { ...phoneValidator(true) }) }}
        isPlaceholder={false}
      />
      <div className="custom-checkbox__container">

      <ConsentInputs errors={errors} control={control} setValue={setValue} email={""} title={t("zgody")} />



        {/* <Controller
          name="acceptRule"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <EACheckbox
              name="acceptRule"
              field={field}
              errors={errors}
              label={
                <span>
                  *{t("akceptuje")} {""}
                  <a target="_blank" rel="noreferrer" href={"https://eaktywni.pl/regulamin/"}>
                    {t("regulamin")} {t("serwisu")} eAktywni.pl
                  </a>
                </span>
              }
            />
          )}
        /> */}
      </div>
      <div className="b2b-register-next">
        <EAButton title="Załóż bezpłatne konto" inputType="submit" />
      </div>
    </>
  );
};

export default FormPart2;
